<script>
import e4parent from "@/components/charts/e4parent";
export default {
  extends: e4parent,
  props: {},
  methods: {
    /* setOption() {
      this.isEmpty = true;
      this.$nextTick(() => {
        this.render(this.getMockData());
      });
    },  */
    getFormatExParams() {
      return {};
    },
    getMockData() {
      let res = {
        data: [
          {
            value: 100,
            name: "未入章",
          },
          {
            value: 200,
            name: "已入章1",
          },
          {
            value: 200,
            name: "已入章2",
          },
          {
            value: 200,
            name: "已入章3",
          },
          {
            value: 200,
            name: "已入章4",
          },
        ],
      };
      return res;
    },
    getLegendData: function (data) {
      let legendData = [];
      let len = data.length;
      for (let i = 0; i < len; i++) {
        let item = data[i];
        let name = item.name;
        legendData.unshift(name);
      }
      return legendData;
    },
    //     avg_score: 15.01
    // date: "2021-06"
    // index_score: "0.0"
    // industry: "电气机械和器材制造业"
    // mark: "E"
    // max_score: "72.750"
    // min_score: "0.000"
    // name: "秦川物联"
    packageData: function (res) {
      // let title = this.title;
      let colorData = this.colorData;
      if (res.code && res.code == 200) {
        var lineOneY = this.formData(res.data, "avg_score");
        var lineTwoY = this.formData(res.data, "min_score");
        var lineThreeY = this.formData(res.data, "max_score");
        var lineFourY = this.formData(res.data, "index_score");
        var lineFiveY = this.formData(res.data, "name");

        var seriesY = {
          lineOneY: lineOneY,
          lineTwoY: lineTwoY,
          lineThreeY: lineThreeY,
          lineFourY: lineFourY,
          lineFiveY: lineFiveY,
        };
        var seriesX = this.formData(res.data, "date");
      } else {
        this.$message.closeAll();
        this.$message({
          message: "查找数据出错",
          type: "error",
          showClose: true,
        });
      }
      let seriesData = { seriesX: seriesX, seriesY: seriesY };

      // let legendData = this.getLegendData(seriesData);
      return {
        // title: title,
        // legendData: legendData,
        seriesData: seriesData,
        colorData: colorData,
      };
    },
    formData(v, m) {
      let arr = [];
      for (var i = 0; i <= v.length - 1; i++) {
        arr.unshift(v[i][m]);
      }
      return arr;
    },
    getEchartsOptions(res) {
      //  ;
      let data = this.packageData(res);
      let option = {
        legend: {
          data: ["最高分", "中国平安", "最低分", "平均分"],
          y: "bottom", // 'center' | 'bottom' | {number}
          itemGap: 30,
          textStyle: {
            color: this.chartsLabelColor || "#333333",
          },
        },
        xAxis: {
          axisTick: { show: false },
          splitLine: { show: false },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#f0f0f0",
            },
          },
          axisLabel: {
            show: true,
            color: this.chartsLabelColor || "#333333",
            fontSize: 14,
          },
          data: data.seriesData.seriesX,
        },
        yAxis: [
          {
            scale: true,
            axisTick: { show: false },
            splitLine: {
              show: true,
              lineStyle: {
                opacity: 0.3,
              },
            },
            axisLine: {
              lineStyle: {
                color: "#f0f0f0",
              },
            },
            axisLabel: {
              show: true,
              color: this.chartsLabelColor || "#333333",
              fontSize: 14,
            },
          },
        ],
        series: [
          {
            name: "平均分",
            type: "line",

            symbol: "circle",
            symbolSize: 3,
            lineStyle: {
              width: 1,
            },
            data: data.seriesData.seriesY.lineOneY,
          },
          {
            name: "最低分",
            type: "line",

            symbol: "circle",
            symbolSize: 3,
            lineStyle: {
              width: 1,
            },
            data: data.seriesData.seriesY.lineTwoY,
          },
          {
            name: "最高分",
            type: "line",

            symbol: "circle",
            symbolSize: 3,
            lineStyle: {
              width: 1,
            },
            data: data.seriesData.seriesY.lineThreeY,
          },
          {
            name: "中国平安",
            type: "line",

            symbol: "circle",
            symbolSize: 3,
            lineStyle: {
              width: 1,
            },
            data: data.seriesData.seriesY.lineFourY,
          },
        ],
      };
      return option;
    },
  },
};
</script>
